import axios from "../../../../axios";
import Cookies from "js-cookie";

export const CGetSelectedCandidate = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetSelectedCandidates", {
    token,
  });
};